import type { PropsWithChildren, ReactNode } from "react";

import logo from "@/assets/Maya-mind_logo_color.png";
import mainBg from "@/assets/main.jpg";
import { cn } from "@/lib/utils";

interface AuthPageShellProps extends PropsWithChildren {
  title: string;
  subtitle?: ReactNode;
  maxWidth?: "md" | "lg";
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
}

const maxWidthClass = {
  md: "max-w-md",
  lg: "max-w-lg",
};

const AuthPageShell = ({
  title,
  subtitle,
  maxWidth = "md",
  className,
  headerClassName,
  contentClassName,
  children,
}: AuthPageShellProps) => {
  return (
    <main
      className="relative flex min-h-dvh items-center justify-center overflow-y-auto bg-cover bg-center bg-no-repeat px-3 py-4 sm:px-4 sm:py-6"
      style={{ backgroundImage: `url(${mainBg})` }}
    >
      <div className="absolute inset-0 bg-black/5 backdrop-blur-[0.2px]" />

      <section className={cn("relative z-10 w-full", maxWidthClass[maxWidth])}>
        <div
          className={cn(
            "flex max-h-[calc(100dvh-2rem)] flex-col overflow-hidden rounded-2xl border border-white/20 bg-white/95 shadow-2xl backdrop-blur-xl",
            className,
          )}
        >
          <div
            className={cn(
              "flex shrink-0 justify-center border-b border-gray-100 bg-white px-5 py-5 sm:py-6",
              headerClassName,
            )}
          >
            <div className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-lg sm:h-20 sm:w-20">
              <img
                src={logo}
                alt="Mayamind"
                className="h-full w-full object-cover scale-[2.2]"
              />
            </div>
          </div>

          <div className="shrink-0 px-5 pt-5 text-center sm:px-8">
            <h1 className="text-2xl font-semibold tracking-tight text-gray-900">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-2 text-sm leading-5 text-gray-500">{subtitle}</p>
            )}
          </div>

          <div
            className={cn(
              "min-h-0 flex-1 overflow-y-auto px-5 pb-6 pt-6 sm:px-8",
              contentClassName,
            )}
          >
            {children}
          </div>
        </div>
      </section>
    </main>
  );
};

export default AuthPageShell;
